/**
 * @file
 * IGSTMA-446 Landing Page - Sticky Footer.
 *
 * @see landing_page_preprocess_html() in web/modules/features/landing_page/landing_page.module
 * @see web/themes/igs/components/pages/landingpage/landingpage_stickyfooter.scss
 */

(function (Drupal, $, once) {
  Drupal.behaviors.landingPageStickyFooter = {
    attach: function (context, settings) {
      $(once('landingPageStickyFooter', '.LandingPageStickyFooter', context)).each(function () {
        var $main_title_mobile = $('.layerlp--intro > .lp-inner-max-width > .layerlp__title', context);
        var $sticky_footer = $('.LandingPageStickyFooter', context);
        var observer = new IntersectionObserver(

          /**
           * IntersectionObserver "observe" callback.
           */
          function(IntersectionObserverEntries) {
            IntersectionObserverEntry = IntersectionObserverEntries[0];
            if (IntersectionObserverEntry.isIntersecting) {
              $sticky_footer.removeClass('js-on').addClass('js-off');
            }
            else {
              $sticky_footer.removeClass('js-off').addClass('js-on');
              // Pour éviter de voir la transition off au chargement de la
              // page sous mobile :
              if (!$sticky_footer.hasClass('js-already-showed-once')) {
                $sticky_footer.addClass('js-already-showed-once');
              }
            }
          }
        );

        observer.observe($main_title_mobile.get(0));
      });
    }
  };
})(Drupal, jQuery, once);
